export {default as ListadoC} from './components/listado';
export {default as AddC} from './components/add';



// WEBPACK FOOTER //
// src/modules/mensajes/component.js